// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1RF6O","select":"Header_select__3C8Pd","clinic":"Header_clinic__3Eou3"};